import { SxProps, Theme } from '@mui/material';

/** CssBaseline 전역 스크롤바 숨김을 덮어쓰는 얇은 스크롤바 (밝은 배경용) */
export const subtleScrollbarSx: SxProps<Theme> = {
  msOverflowStyle: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
  '&::-webkit-scrollbar': {
    display: 'block',
    width: 4,
    height: 4,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.18)',
    borderRadius: 4,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
};

/** 사이드 메뉴 등 어두운/컬러 배경용 */
export const subtleScrollbarOnDarkSx: SxProps<Theme> = {
  msOverflowStyle: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(255, 255, 255, 0.35) transparent',
  '&::-webkit-scrollbar': {
    display: 'block',
    width: 4,
    height: 4,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255, 255, 255, 0.28)',
    borderRadius: 4,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.45)',
  },
};

export const subtleScrollbarCss = `
  -ms-overflow-style: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  &::-webkit-scrollbar {
    display: block;
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.18);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

export const subtleScrollbarOnDarkCss = `
  -ms-overflow-style: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.35) transparent;

  &::-webkit-scrollbar {
    display: block;
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.28);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.45);
  }
`;
